export class OrgSaasAccountCost {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "eonAccountId",
            "baseName": "eonAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "accountDomain",
            "baseName": "accountDomain",
            "type": "string",
            "format": ""
        },
        {
            "name": "saasApps",
            "baseName": "saasApps",
            "type": "Array<SaasAppCost>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OrgSaasAccountCost.attributeTypeMap;
    }
    constructor() {
    }
}
